import { SET_ADDITIONAL_BAGS_PREFERENCE } from '../actions/delivery/deliveryPreferences';
import {
  CLOSE_REMOVE_NUMBER_CONFIRM,
  OPEN_REMOVE_NUMBER_CONFIRM,
  SET_CURRENT_SMS_NUMBER,
  SET_SMS_ALERT_SETTINGS,
} from '../actions/delivery/smsAlerts';
import {
  ADDRESS_BOOK_RESET_ADD_ADDRESS_FORM,
  ADDRESS_BOOK_SET_ADDRESSES_FOR_POSTCODE,
  ADDRESS_BOOK_SET_DELIVERY_ADDRESS_TO_EDIT,
  ADDRESS_BOOK_SET_MANUAL_ADDRESS_ERROR,
  ADDRESS_BOOK_SET_CITY_ERROR,
  ADDRESS_BOOK_SET_POSTCODE_ERROR_CODE,
  ADDRESS_BOOK_TOGGLE_MANUAL_ADDRESS_ENTERING,
  ADDRESS_BOOK_UPDATE_FIELD,
  SET_DELETE_DELIVERY_ADDRESS_ERROR,
  SET_DELIVERY_ADDRESSES,
  SET_OVERRIDE_DELIVERY_ADDRESS_ERROR,
} from '../actions/delivery/deliveryAddressBook';
import {
  addressBookResetAddAddressForm,
  addressBookSetAddressesForPostCode,
  addressBookSetDeliveryAddressToEdit,
  addressBookSetManualAddressError,
  addressBookSetCityError,
  addressBookSetPostcodeErrorCode,
  addressBookToggleManualAddressEntering,
  addressBookUpdateField,
} from './delivery/settingsAddressBookActions';
import {
  setDeleteDeliveryAddressError,
  setDeliveryAddresses,
  setOverrideDeliveryAddressError,
} from './delivery/settingsDeliveryAddressActions';

export const settingsDeliveryActions = {
  /* Delivery Addresses */
  [SET_DELIVERY_ADDRESSES]: setDeliveryAddresses,
  [SET_DELETE_DELIVERY_ADDRESS_ERROR]: setDeleteDeliveryAddressError,
  [SET_OVERRIDE_DELIVERY_ADDRESS_ERROR]: setOverrideDeliveryAddressError,
  [ADDRESS_BOOK_SET_ADDRESSES_FOR_POSTCODE]: addressBookSetAddressesForPostCode,
  [ADDRESS_BOOK_RESET_ADD_ADDRESS_FORM]: addressBookResetAddAddressForm,
  [ADDRESS_BOOK_SET_POSTCODE_ERROR_CODE]: addressBookSetPostcodeErrorCode,
  [ADDRESS_BOOK_SET_MANUAL_ADDRESS_ERROR]: addressBookSetManualAddressError,
  [ADDRESS_BOOK_SET_CITY_ERROR]: addressBookSetCityError,
  [ADDRESS_BOOK_TOGGLE_MANUAL_ADDRESS_ENTERING]: addressBookToggleManualAddressEntering,
  [ADDRESS_BOOK_UPDATE_FIELD]: addressBookUpdateField,
  [ADDRESS_BOOK_SET_DELIVERY_ADDRESS_TO_EDIT]: addressBookSetDeliveryAddressToEdit,
  /* Delivery SMS Reminders */
  [SET_SMS_ALERT_SETTINGS]: ({ state, action }) => ({
    ...state,
    currentSmsNumber: action.currentSmsNumber,
    primaryNumber: action.primaryNumber,
    secondaryNumber: action.secondaryNumber,
    hasSlotSubscription: action.hasSlotSubscription,
  }),
  [SET_CURRENT_SMS_NUMBER]: ({ state, action }) => ({ ...state, currentSmsNumber: action.currentSmsNumber }),
  [OPEN_REMOVE_NUMBER_CONFIRM]: ({ state }) => ({ ...state, isRemoveNumberConfirmOpen: true }),
  [CLOSE_REMOVE_NUMBER_CONFIRM]: ({ state }) => ({ ...state, isRemoveNumberConfirmOpen: false }),
  /* Delivery Preferences */
  [SET_ADDITIONAL_BAGS_PREFERENCE]: ({ state, action }) => ({ ...state, useAdditionalBags: action.useAdditionalBags }),

};
